module.exports = __webpack_public_path__ + "fonts/GothamPro-Regular.woff?3cb46b372ab77d032576b9f70c83d1ff";